import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Row, Col, Card, Spinner, Badge, Tabs, Tab, Button, Table, Pagination, Modal, Form } from "react-bootstrap";
import {
  FaSchool, FaCode, FaEnvelope, FaPhone, FaMapMarkerAlt,
  FaCalendarAlt, FaChalkboardTeacher, FaUsers, FaFileAlt,
  FaBuilding, FaGlobe, FaLink, FaUserTie, FaImage, FaFile,
  FaArrowLeft, FaEdit, FaCheckCircle, FaTimesCircle,
  FaRegistered, FaCalendar, FaFax, FaGlobeAmericas, FaEye, FaTrash, FaPlus
} from "react-icons/fa";


import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import { ToastContainer, toast } from "react-toastify";
import { formateDatemdy } from "../../utils/Helper";
import DeleteModal from "../../components/common/DeleteModel";
import Select from "react-select";
import {
  capitalizeFirstLetterOfEveryWord
} from "../../utils/Helper";
import useMenuPermissions from "../../components/CustomHook/custompermission";
const SchoolDetails = () => {
  const { id } = useParams();
  const permissionscontextCourse = useMenuPermissions("/admin/course");
  const navigate = useNavigate();
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);

  const [courses, setCourses] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(false);
  const [coursesTotal, setCoursesTotal] = useState(0);
  const [coursesCurrentPage, setCoursesCurrentPage] = useState(1);
  const coursesLimit = 10;
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [selectedCourseId, setSelectedCourseId] = useState("");
  const [allCourses, setAllCourses] = useState([]);
  const [loadingCoursesList, setLoadingCoursesList] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [students, setStudents] = useState([]);
  const [loadingStudents, setLoadingStudents] = useState(false);
  const [studentsTotal, setStudentsTotal] = useState(0);
  const [studentsCurrentPage, setStudentsCurrentPage] = useState(1);
  const [studentFilters, setStudentFilters] = useState({
    search: "",
    grade_id: ""
  });
  const [grades, setGrades] = useState([]);
  const [loadingGrades, setLoadingGrades] = useState(false);
  const studentsLimit = 10;

  const headers = {
    "auth-token": authToken,
    "authorization": accessToken
  };

  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);

  const [loading, setLoading] = useState(false);
  const [schoolData, setSchoolData] = useState(null);
  const [activeTab, setActiveTab] = useState('info');
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    if (id) {
      fetchSchoolDetails();
    }
  }, [id]);

  useEffect(() => {
    if (showAssignModal) {
      fetchAllCourses();
    }
  }, [showAssignModal]);

  const fetchSchoolDetails = async () => {
    setLoading(true);
    try {
      const response = await APIServices.get(
        `/admin/school/details/${id}`,
        headers
      );

      if (response?.data?.status === true) {
        setSchoolData(response?.data?.data);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        showToast(response?.data?.message || "Error fetching school details", "error");
      }
    } catch (error) {
      console.error("Error fetching school details:", error);
      showToast("Error fetching school details", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchGrades = async () => {
    setLoadingGrades(true);
    try {
      const response = await APIServices.get(
        `/admin/cms/grade_list?status=Active&limit=100`,
        headers
      );
      if (response?.data?.status === true) {
        const gradesData = response?.data?.data?.grades || response?.data?.data?.data || [];
        setGrades(gradesData);
      }
    } catch (error) {
      console.error("Error fetching grades:", error);
    } finally {
      setLoadingGrades(false);
    }
  };

  const fetchSchoolStudents = async (page = 1) => {
    setLoadingStudents(true);
    try {
      const skip = (page - 1) * studentsLimit;
      let url = `/admin/student/list?skip=${skip}&limit=${studentsLimit}&school_id=${id}`;

      if (studentFilters.search) {
        url += `&search=${studentFilters.search}`;
      }
      if (studentFilters.grade_id) {
        url += `&grade_id=${studentFilters.grade_id}`;
      }

      const response = await APIServices.get(url, headers);

      if (response?.data?.status === true) {
        setStudents(response?.data?.data?.data || []);
        setStudentsTotal(response?.data?.data?.total || 0);
      }
    } catch (error) {
      console.error("Error fetching students:", error);
      showToast("Error fetching students", "error");
    } finally {
      setLoadingStudents(false);
    }
  };

  useEffect(() => {
    fetchGrades();
  }, []);

  useEffect(() => {
    if (activeTab === 'student' && id) {
      fetchSchoolStudents(studentsCurrentPage);
    }
  }, [activeTab, id, studentsCurrentPage, studentFilters]);

  useEffect(() => {
    if (activeTab === 'course' && id) {
      fetchSchoolCourses(coursesCurrentPage);
    }
  }, [activeTab, id, coursesCurrentPage]);


  const handleStudentSearch = (e) => {
    setStudentFilters(prev => ({ ...prev, search: e.target.value }));
    setStudentsCurrentPage(1);
  };

  const handleGradeFilter = (e) => {
    setStudentFilters(prev => ({ ...prev, grade_id: e.target.value }));
    setStudentsCurrentPage(1);
  };

  const clearStudentFilters = () => {
    setStudentFilters({ search: "", grade_id: "" });
    setStudentsCurrentPage(1);
  };

  const fetchSchoolCourses = async (page = 1) => {
    setLoadingCourses(true);
    try {
      const skip = (page - 1) * coursesLimit;
      const response = await APIServices.get(
        `/admin/courses/mapping/school-courses/${id}?skip=${skip}&limit=${coursesLimit}`,
        headers
      );

      if (response?.data?.status === true) {
        setCourses(response?.data?.data?.courses || []);
        setCoursesTotal(response?.data?.data?.total || 0);
      }
    } catch (error) {
      console.error("Error fetching school courses:", error);
      showToast("Error fetching courses", "error");
    } finally {
      setLoadingCourses(false);
    }
  };

  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };

  const getStatusBadge = (status) => {
    if (status === "Active") {
      return <Badge bg="success" className="px-3 py-2">Active</Badge>;
    } else if (status === "Inactive") {
      return <Badge bg="danger" className="px-3 py-2">Inactive</Badge>;
    }
    return <Badge bg="secondary" className="px-3 py-2">Unknown</Badge>;
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2">Loading school details...</p>
      </div>
    );
  }

  if (!schoolData) {
    return (
      <div className="text-center py-5">
        <p>No data found</p>
        <Button variant="primary" onClick={() => navigate("/admin/school")}>
          Back to Schools
        </Button>
      </div>
    );
  }

  const handleRemoveCourse = async () => {
    try {
      const formData = new FormData();
      formData.append("course_id", selectedCourse.id);
      formData.append("school_id", id);

      const response = await APIServices.delete(
        "/admin/courses/mapping/delete",
        formData,
        {
          ...headers,
          'Content-Type': 'multipart/form-data'
        }
      );

      if (response?.data?.status === true) {
        showToast(response?.data?.message || "Course removed from school successfully", "success");
        // Refresh the courses list
        fetchSchoolCourses(coursesCurrentPage);
        setShowDeleteModal(false);
        setSelectedCourse(null);
      } else {
        showToast(response?.data?.message || "Something went wrong", "error");
      }
    } catch (error) {
      console.error("Error removing course:", error);
      showToast("Error removing course from school", "error");
    }
  };


  const fetchAllCourses = async () => {
    setLoadingCoursesList(true);
    try {
      const [allRes, assignedRes] = await Promise.all([
        APIServices.get(`/admin/courses/short/list`, headers),
        APIServices.get(`/admin/courses/mapping/school-courses/${id}?skip=0&limit=9999`, headers),
      ]);

      const assignedIds = new Set(
        (assignedRes?.data?.data?.courses || []).map(c => c.id)
      );

      if (allRes?.data?.status === true) {
        const coursesData = allRes?.data?.data?.data || [];
        const formattedCourses = coursesData
          .filter(course => !assignedIds.has(course.id))
          .map(course => ({
            value: course.id,
            label: `${course.title} (${course.unique_course_id})`
          }));
        setAllCourses(formattedCourses);
      }
    } catch (error) {
      console.error("Error fetching courses:", error);
      showToast("Error fetching courses", "error");
    } finally {
      setLoadingCoursesList(false);
    }
  };

  const handleAssignCourse = async () => {
    if (!selectedCourse) {
      showToast("Please select a course", "error");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("school_id", id);
      formData.append("course_id", selectedCourse.value);

      const response = await APIServices.post(
        "/admin/courses/mapping/add",
        formData,
        {
          ...headers,
          'Content-Type': 'multipart/form-data'
        }
      );

      if (response?.data?.status === true) {
        showToast(response?.data?.message || "Course assigned successfully", "success");
        setShowAssignModal(false);
        setSelectedCourse(null);
        setSelectedCourseId("");
        // Refresh the courses list
        fetchSchoolCourses(coursesCurrentPage);
      } else {
        showToast(response?.data?.message || "Something went wrong", "error");
      }
    } catch (error) {
      console.error("Error assigning course:", error);
      showToast("Error assigning course to school", "error");
    }
  };

  return (
    <>
      <div className="school-details-page">
        <div className="d-flex justify-content-between align-items-center mb-4">

          {/* Left side */}
          <h1 className="font_blue_18 font-600 ms-2">
            School Details
          </h1>

          {/* Right side */}
          <div className="d-flex gap-2">
            {permissionscontextCourse.add == 1 && <Button
              variant="primary"
              onClick={() => navigate("/admin/add-course?school_id=" + id)}
              title="Create course for this school"
            >
              <FaPlus className="me-1" /> Create Course
            </Button>}

            <Button
              variant="outline-secondary"
              onClick={() => navigate("/admin/school")}
            >
              <FaArrowLeft className="me-1" /> Back
            </Button>
          </div>

        </div>

        <Row>
          {/* Left Sidebar - 4 Columns - Single Card */}
          <Col md={4}>
            <Card>
              <Card.Body>
                {/* Logo */}
                <div className="text-center mb-3">
                  {schoolData.logo ? (
                    <img
                      src={schoolData.logo}
                      alt={schoolData.school_name}
                      style={{
                        width: '120px',
                        height: '120px',
                        objectFit: 'cover',
                        borderRadius: '50%',
                        marginBottom: '10px'
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: '120px',
                        height: '120px',
                        backgroundColor: '#f0f0f0',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 10px auto'
                      }}
                    >
                      <FaSchool size={50} color="#999" />
                    </div>
                  )}
                  <h4> <strong>{capitalizeFirstLetterOfEveryWord(schoolData.school_name)}</strong></h4>
                  <div className="mt-2">
                    {getStatusBadge(schoolData.status)}
                  </div>
                </div>

                <hr />

                {/* School Details */}
                <div className="school-info">
                  <div className="d-flex justify-content-between mb-3 mt-2 pb-2">
                    <strong>School Code:</strong>
                    <span>{schoolData.school_code}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-3 mt-2 pb-2">
                    <strong>Registration Number:</strong>
                    <span>{schoolData.registration_number}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-3 mt-2 pb-2">
                    <strong>School Type:</strong>
                    <span>{schoolData.school_type}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-3 mt-2 pb-2">
                    <strong>Email:</strong>
                    <span>{schoolData.email}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-3 mt-2 pb-2">
                    <strong>Mobile:</strong>
                    <span>{schoolData.country_code_value}-{schoolData.mobile}</span>
                  </div>
                  {schoolData.fax && (
                    <div className="d-flex justify-content-between mb-3 mt-2 pb-2">
                      <strong>Fax:</strong>
                      <span>{schoolData.fax}</span>
                    </div>
                  )}
                  <div className="d-flex justify-content-between mb-3 mt-2 pb-2">
                    <strong>Established Year:</strong>
                    <span>{schoolData.established_year || 'N/A'}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-3 mt-2 pb-2">
                    <strong>Total Students:</strong>
                    <span>{schoolData.no_of_student || 'N/A'}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-3 mt-2 pb-2">
                    <strong>Total Teachers:</strong>
                    <span>{schoolData.no_of_teacher || 'N/A'}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-3 mt-2 pb-2">
                    <strong>Created At:</strong>
                    <span>{formateDatemdy(schoolData.created_at)}</span>
                  </div>

                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* Right Content - 8 Columns with 3 Tabs */}
          <Col md={8}>
            <Card>
              <Card.Body>
                <Tabs
                  activeKey={activeTab}
                  onSelect={(k) => setActiveTab(k)}
                  className="mb-3"
                >
                  {/* Tab 1: SCHOOL INFO */}
                  <Tab eventKey="info" title="School Info">
                    <div className="p-3">
                      <div className="card p-3 shadow-sm">
                        <h6 className="text-primary mb-3">School Information</h6>

                        <div className="row">

                          {/* Address */}
                          <div className="col-md-6 mb-3">
                            <div className="text-muted small">Address</div>
                            <div className="fw-semibold">{schoolData.address || 'N/A'}</div>
                          </div>

                          {/* City */}
                          <div className="col-md-6 mb-3">
                            <div className="text-muted small">City</div>
                            <div className="fw-semibold">{schoolData.city_name || 'N/A'}</div>
                          </div>

                          {/* State */}
                          <div className="col-md-6 mb-3">
                            <div className="text-muted small">State</div>
                            <div className="fw-semibold">{schoolData.state_name || 'N/A'}</div>
                          </div>

                          {/* Country */}
                          <div className="col-md-6 mb-3">
                            <div className="text-muted small">Country</div>
                            <div className="fw-semibold">{schoolData.country_name || 'N/A'}</div>
                          </div>

                          {/* Zip Code */}
                          <div className="col-md-6 mb-3">
                            <div className="text-muted small">Zip Code</div>
                            <div className="fw-semibold">{schoolData.zip_code || 'N/A'}</div>
                          </div>

                          {/* Fax  */}
                          <div className="col-md-6 mb-3">
                            <div className="text-muted small">Fax</div>
                            <div className="fw-semibold">{schoolData.fax || 'N/A'}</div>
                          </div>

                          {/* Website */}
                          <div className="col-md-6 mb-3">
                            <div className="text-muted small">Website</div>
                            <div className=" text-primary">
                              {schoolData.website ? (
                                <a href={schoolData.website} target="_blank" rel="noopener noreferrer">
                                  {schoolData.website}
                                </a>
                              ) : 'N/A'}
                            </div>
                          </div>

                          {/* Social Links */}
                          <div className="col-md-6 mb-3">
                            <div className="text-muted small">Social Links</div>
                            <div>
                              {schoolData.social_link ? (
                                schoolData.social_link.split(',').map((link, index) => (
                                  <div key={index} className="text-primary">
                                    <a href={link.trim()} target="_blank" rel="noopener noreferrer">
                                      {link.trim()}
                                    </a>
                                  </div>
                                ))
                              ) : 'N/A'}
                            </div>
                          </div>

                          {/* Grades */}
                          <div className="col-md-6 mb-3">
                            <div className="text-muted small">Grades Offered</div>
                            <div>
                              {schoolData.grade_arr?.length > 0 ? (
                                schoolData.grade_arr.map((grade, index) => (
                                  <Badge key={index} bg="info" className="me-1 mb-1">
                                    {grade}
                                  </Badge>
                                ))
                              ) : 'N/A'}
                            </div>
                          </div>

                          {/* Document */}
                          <div className="col-md-6 mb-3">
                            <div className="text-muted small">Document</div>
                            <div>
                              {schoolData.documents ? (
                                <Button
                                  as="a"
                                  href={schoolData.documents}
                                  download
                                  variant="outline-primary"
                                  size="sm"
                                  target="_blank"
                                >
                                  Download
                                </Button>
                              ) : 'N/A'}
                            </div>
                          </div>
                          <div className="col-md-12 mb-12">
                            <h6 className="text-primary mb-3 mt-2">Contact Persons</h6>
                            {schoolData.contact_persons && schoolData.contact_persons.length > 0 ? (
                              <Table responsive className="table">
                                <thead>
                                  <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Designation</th>
                                    <th>Email</th>
                                    <th>Phone</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {schoolData.contact_persons.map((person, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{person.name}</td>
                                      <td>{person.designation}</td>
                                      <td>{person.email}</td>
                                      <td>{person.phone}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            ) : (
                              <p>No contact persons added</p>
                            )}
                          </div>

                        </div>
                      </div>
                    </div>
                  </Tab>

                  <Tab eventKey="course" title="Courses">
                    <div className="p-3">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="text-primary mb-0">Assign Courses</h6>
                        {permissionscontextCourse.add == 1  &&
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={() => setShowAssignModal(true)}
                          >
                            <FaPlus className="me-1" /> Assign Course
                          </Button>
                        }
                      </div>
                      {loadingCourses ? (
                        <div className="text-center py-4">
                          <Spinner animation="border" variant="primary" />
                        </div>

                      ) : courses.length > 0 ? (
                        <>
                          <Table responsive className="table">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Course ID</th>
                                <th>Image</th>
                                <th>Title</th>
                                <th>Duration</th>
                                <th>Language</th>
                                <th>No of Grades</th>
                                <th>Expiry Date</th>
                                <th>Created Date</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {courses.map((course, index) => (
                                <tr key={course.id}>
                                  <td>{((coursesCurrentPage - 1) * coursesLimit) + index + 1}</td>
                                  <td>{course.unique_course_id}</td>
                                  <td>
                                    {course.image ? (
                                      <img
                                        src={course.image}
                                        alt={course.title}
                                        style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '5px' }}
                                        onError={(e) => {
                                          e.target.onerror = null;
                                          e.target.src = '/images/no-image.png';
                                        }}
                                      />
                                    ) : (
                                      <div style={{ width: '50px', height: '50px', backgroundColor: '#f0f0f0', borderRadius: '5px' }}></div>
                                    )}
                                  </td>
                                  <td>
                                    <strong>{course.title}</strong>
                                    <br />
                                    <small className="text-muted">{course.sub_title?.substring(0, 50)}...</small>
                                  </td>
                                  <td>{course.duration}</td>
                                  <td>{course.language}</td>
                                  <td>
                                    <>
                                      {course.grade_names?.length || 0} 
                                    </>
                                  </td>
                                  <td>
                                    {course.expiry_date && new Date(course.expiry_date) < new Date() ? (
                                      <Badge bg="danger">Expired</Badge>
                                    ) : (

                                      formateDatemdy(course.expiry_date)
                                    )}
                                  </td>
                                  <td>{formateDatemdy(course.created_at)}</td>
                                  <td>
                                    <div className="d-flex gap-2">
                                      <Button
                                        variant="outline-info"
                                        size="sm"
                                        onClick={() => navigate(`/admin/course-detail/${course.id}`)}
                                        title="View Course Details"
                                      >
                                        <FaEye />
                                      </Button>
                                      {permissionscontextCourse.delete == 1 && <Button
                                        variant="outline-danger"
                                        size="sm"
                                        onClick={() => {
                                          setSelectedCourse(course);
                                          setShowDeleteModal(true);
                                        }}
                                        title="Remove course from school"
                                      >
                                        <FaTrash />
                                      </Button>}
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                          {/* Pagination */}
                          {coursesTotal > coursesLimit && (
                            <div className="d-flex justify-content-end mt-3">
                              <Pagination>
                                <Pagination.Prev
                                  disabled={coursesCurrentPage === 1}
                                  onClick={() => setCoursesCurrentPage(prev => prev - 1)}
                                />
                                {[...Array(Math.ceil(coursesTotal / coursesLimit))].map((_, i) => (
                                  <Pagination.Item
                                    key={i + 1}
                                    active={coursesCurrentPage === i + 1}
                                    onClick={() => setCoursesCurrentPage(i + 1)}
                                  >
                                    {i + 1}
                                  </Pagination.Item>
                                ))}
                                <Pagination.Next
                                  disabled={coursesCurrentPage === Math.ceil(coursesTotal / coursesLimit)}
                                  onClick={() => setCoursesCurrentPage(prev => prev + 1)}
                                />
                              </Pagination>
                            </div>
                          )}
                        </>
                      ) : (
                        <div className="text-center py-4">
                          <p className="text-muted">No courses assigned to this school</p>
                        </div>
                      )}
                    </div>
                  </Tab>

                  <Tab eventKey="student" title="Students">
                    <div className="p-3">
                      <div className="d-flex justify-content-between align-items-center mb-3 gap-2 flex-wrap">
                        <h6 className="text-primary mb-0">Student List ({studentsTotal})</h6>
                        <div className="d-flex gap-2 flex-wrap">
                                  {/* ADD THIS BUTTON - Add Student Button */}
                          <Button
                            variant="success"
                            size="sm"
                            onClick={() => navigate(`/admin/add-student?school_id=${id}`)}
                          >
                            <FaPlus className="me-1" /> Add Student
                          </Button>
                          {/* Search Input */}
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search by name, roll number..."
                            value={studentFilters.search}
                            onChange={handleStudentSearch}
                            style={{ width: '200px' }}
                          />

                          {/* Grade Filter */}
                          <Form.Select
                            value={studentFilters.grade_id}
                            onChange={handleGradeFilter}
                            style={{ width: '150px' }}
                          >
                            <option value="">All Grades</option>
                            {grades.map(grade => (
                              <option key={grade.id} value={grade.id}>{grade.name}</option>
                            ))}
                          </Form.Select>

                          {/* Clear Filters Button */}
                          {(studentFilters.search || studentFilters.grade_id) && (
                            <Button variant="outline-danger" size="sm" onClick={clearStudentFilters}>
                              Clear Filters
                            </Button>
                          )}
                        </div>
                      </div>

                      {loadingStudents ? (
                        <div className="text-center py-4">
                          <Spinner animation="border" variant="primary" />
                        </div>
                      ) : students.length > 0 ? (
                        <>
                          <Table responsive className="table">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Roll Number</th>
                                <th>Student Name</th>
                                <th>Email</th>
                                <th>Mobile</th>
                                <th>Grade</th>
                                <th>Status</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {students.map((student, index) => (
                                <tr key={student.id}>
                                  <td>{((studentsCurrentPage - 1) * studentsLimit) + index + 1}</td>
                                  <td>{student.roll_number}</td>
                                  <td>{student.first_name} {student.last_name}</td>
                                  <td>{student.email}</td>
                                  <td>{student.country_code}-{student.mobile}</td>
                                  <td><Badge bg="info">{student.grade_name}</Badge></td>
                                  <td>
                                    <Badge bg={student.status === "Active" ? "success" : "danger"}>
                                      {student.status}
                                    </Badge>
                                  </td>
                                  <td>
                                    <div className="d-flex gap-2">
                                      <Button
                                        variant="outline-info"
                                        size="sm"
                                        onClick={() => navigate(`/admin/student-detail/${student.id}`)}
                                        title="View Student Details"
                                      >
                                        <FaEye />
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>

                          {/* Pagination */}
                          {studentsTotal > studentsLimit && (
                            <div className="d-flex justify-content-end mt-3">
                              <Pagination>
                                <Pagination.Prev
                                  disabled={studentsCurrentPage === 1}
                                  onClick={() => setStudentsCurrentPage(prev => prev - 1)}
                                />
                                {[...Array(Math.ceil(studentsTotal / studentsLimit))].map((_, i) => (
                                  <Pagination.Item
                                    key={i + 1}
                                    active={studentsCurrentPage === i + 1}
                                    onClick={() => setStudentsCurrentPage(i + 1)}
                                  >
                                    {i + 1}
                                  </Pagination.Item>
                                ))}
                                <Pagination.Next
                                  disabled={studentsCurrentPage === Math.ceil(studentsTotal / studentsLimit)}
                                  onClick={() => setStudentsCurrentPage(prev => prev + 1)}
                                />
                              </Pagination>
                            </div>
                          )}
                        </>
                      ) : (
                        <div className="text-center py-4">
                          <p className="text-muted">No students found in this school</p>
                        </div>
                      )}
                    </div>
                  </Tab>
                </Tabs>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      {/* Delete Confirmation Modal */}
      <DeleteModal
        showdt={showDeleteModal}
        handleCloseDt={() => {
          setShowDeleteModal(false);
          setSelectedCourse(null);
        }}
        handledelete={handleRemoveCourse}
        title="Remove Course"
        message={`Are you sure you want to remove this course from this school?`}
      />

      {/* Assign Course Modal */}
      <Modal
        show={showAssignModal}
        onHide={() => {
          setShowAssignModal(false);
          setSelectedCourse(null);
          setSelectedCourseId("");
        }}
        centered
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Assign Course to School</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>School</Form.Label>
              <Form.Control
                type="text"
                value={schoolData?.school_name}
                disabled
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Select Course <span className="text-danger">*</span></Form.Label>
              {loadingCoursesList ? (
                <div className="text-center py-2">
                  <Spinner animation="border" size="sm" />
                  <span className="ms-2">Loading courses...</span>
                </div>
              ) : (
                <Select
                  options={allCourses}
                  value={selectedCourse}
                  onChange={setSelectedCourse}
                  placeholder="Search and select a course..."
                  isClearable
                  isSearchable
                  noOptionsMessage={({ inputValue }) =>
                    inputValue ? `No courses found matching "${inputValue}"` : "Type to search courses..."
                  }
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: '42px',
                      borderColor: '#ced4da',
                      '&:hover': {
                        borderColor: '#80bdff'
                      }
                    })
                  }}
                />
              )}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowAssignModal(false);
            setSelectedCourse(null);
            setSelectedCourseId("");
          }}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleAssignCourse}>
            Assign Course
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer />
    </>
  );
};

export default SchoolDetails;